<template>
  <div class="container" style="margin-top:-80px;background-color: #B62D2E">
    <!-- PC端页脚（保留原有逻辑） -->
    <div class="container-bottom" :style="{'background-color':$route.path=='/home'?'':'#B62D2E'}">
      <div class="container-bottom-text">
              <span>
                <span class="cursor-pointer" @click="onContact">{{ $t('other.contact') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onSitemap">{{ $t('other.sitemap') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onPrivacy">{{ $t('other.privacy') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onDisclaimer">{{ $t('other.disclaimer') }}</span>
              </span>
        <br>
        <span>© 2026 {{ $t('other.version') }}</span>
      </div>
    </div>

    <!-- 优化后的手机端页脚 -->
    <div class="container-bottom-phone">
      <!-- 链接区域：改为网格布局，更紧凑且点击区域大 -->
      <div class="phone-link-grid">
        <span class="cursor-pointer phone-link-item" @click="onContact">{{ $t('other.contact') }}</span>
        <span class="phone-divider">|</span>
        <span class="cursor-pointer phone-link-item" @click="onSitemap">{{ $t('other.sitemap') }}</span>
        <span class="phone-divider">|</span>
        <span class="cursor-pointer phone-link-item" @click="onPrivacy">{{ $t('other.privacy') }}</span>
        <span class="phone-divider">|</span>
        <span class="cursor-pointer phone-link-item" @click="onDisclaimer">{{ $t('other.disclaimer') }}</span>
      </div>
      <!-- 版权信息：单独成行，居中显示 -->
      <div class="phone-copyright">
        © 2026 {{ $t('other.version') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    onContact(){
      this.$router.push({ name: "contact" });
    },
    onSitemap(){
      this.$router.push({ name: "sitemap" });
    },
    onRefund(){
      this.$router.push({ name: "refund" });
    },
    onPrivacy(){
      this.$router.push({ name: "privacy" });
    },
    onDisclaimer(){
      this.$router.push({ name: "disclaimer" });
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义响应式断点（统一管理）
$phoneMaxWidth: 767px;

// PC端页脚样式（保留）
.container-bottom {
  display: flex;
  width: 100%;
  height: 5.5rem;
  justify-content: center;
  align-items: center;
  background-color: #B62D2E;

  .container-bottom-text {
    flex-direction: column;
    align-items: center;
    color: white;
    line-height: 1.375rem;
    padding: 0 2rem;
    text-align: center;
  }
}

// 通用点击样式
.cursor-pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8; // 增加hover反馈
  }
}

// ===================== 手机端核心优化 =====================
.container-bottom-phone {
  display: none; // 默认隐藏，媒体查询中显示
}

// 手机端适配（767px以下）
@media (max-width: $phoneMaxWidth) {
  // 隐藏PC端
  .container-bottom {
    display: none;
  }

  // 手机端页脚容器
  .container-bottom-phone {
    display: flex;
    flex-direction: column; // 垂直布局：链接在上，版权在下
    width: 100%;
    background-color: #B62D2E;
    padding: 1rem 3vw; // 上下内边距，左右适配屏幕
    box-sizing: border-box;
    min-height: 80px; // 保证最小高度，避免内容挤压
    justify-content: center; // 垂直居中
    align-items: center; // 水平居中
  }

  // 链接网格：自动换行，间距合理
  .phone-link-grid {
    display: flex;
    flex-wrap: wrap; // 超出自动换行
    justify-content: center; // 居中对齐
    align-items: center;
    margin-bottom: 0.8rem; // 与版权信息的间距
    width: 100%;
    max-width: 350px; // 限制最大宽度，避免太宽

    // 单个链接项
    .phone-link-item {
      color: white;
      font-size: 0.9rem; // 手机端字体缩小，更适配
      padding: 0.3rem 0.5rem; // 增加点击区域
      line-height: 1.4;
      text-align: center;
      flex-shrink: 0; // 防止文字被挤压
    }

    // 分隔符：替换el-divider，更轻量且适配手机
    .phone-divider {
      color: rgba(255, 255, 255, 0.7); // 半透明白色，不刺眼
      margin: 0 0.3rem; // 缩小分隔符间距
      font-size: 0.8rem;
    }
  }

  // 版权信息
  .phone-copyright {
    color: rgba(255, 255, 255, 0.9); // 略淡于链接，层次分明
    font-size: 0.8rem; // 更小的字体
    line-height: 1.5;
    text-align: center;
    width: 100%;
  }

  // 点击反馈强化
  .cursor-pointer {
    transition: opacity 0.2s ease; // 平滑过渡
    &:active {
      opacity: 0.6; // 点击时加深，提升移动端交互感
    }
  }
}

// 平板/PC端样式
@media (min-width: $phoneMaxWidth + 1px) {
  .container-bottom-text {
    text-align: center; // PC端文字居中
  }
}
</style>